import store from '@/store';
import { name as userModuleName } from '@/store/modules/user';

const isAuthenticated = () => {
  return store.getters[`${userModuleName}/isLoggedIn`];
};

export const authHandler = (config) => {
  if (isAuthenticated()) {
    config.headers.Authorization = `bearer ${
      store.getters[`${userModuleName}/accessToken`]
    }`;
  } else {
    config.headers.Authorization = undefined;
  }
};
